<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="12" fill="#1149FF"/>
<g clip-path="url(#clip0_52_7852)">
<path d="M6.66553 10.2947C6.66553 7.03107 9.05914 4.59375 12.4457 4.59375C15.8056 4.59375 18.2701 7.03107 18.2701 10.3398C18.2701 13.5813 15.8951 15.9956 12.3304 15.9956H9.57775V19.2265C9.57775 19.3831 9.55559 19.4034 9.40045 19.4034H8.12164C8.12164 19.4034 6.99975 19.4034 6.84283 19.4034C6.68592 19.4034 6.66553 19.3813 6.66553 19.2265V10.2947ZM15.3579 10.3168C15.3579 8.59343 14.2825 7.27701 12.4457 7.27701C10.584 7.27701 9.57775 8.59608 9.57775 10.2947V13.3132H12.3331C14.2825 13.3132 15.3579 12.0384 15.3579 10.3168Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_52_7852">
<rect width="11.6997" height="14.8097" fill="white" transform="translate(6.5625 4.59375)"/>
</clipPath>
</defs>
</svg>
